module.exports = __webpack_public_path__ + "img/img_wd_bg切图用.d734f6f3.png";